// @ts-ignore
import structuredClone from '@ungap/structured-clone';
import { Platform } from 'react-native';

// ref: https://github.com/vercel/ai/pull/4706/files
if (Platform.OS !== 'web') {
  const setupPolyfills = async () => {
    // @ts-ignore
    const { polyfillGlobal } = await import(
      // @ts-ignore
      'react-native/Libraries/Utilities/PolyfillFunctions'
    );

    const { TextEncoderStream, TextDecoderStream } = await import(
      '@stardazed/streams-text-encoding'
    );

    if (!('structuredClone' in global)) {
      polyfillGlobal('structuredClone', () => structuredClone);
    }

    polyfillGlobal('TextEncoderStream', () => TextEncoderStream);
    polyfillGlobal('TextDecoderStream', () => TextDecoderStream);

    // for react-native-svg until/if https://github.com/software-mansion/react-native-svg/pull/2632 gets merged
    const { Buffer } = await import('buffer');
    polyfillGlobal('Buffer', () => Buffer);

    // for eciesjs
    const { getRandomValues } = await import('expo-crypto');
    polyfillGlobal('crypto', () => ({
      getRandomValues
    }));
  };

  setupPolyfills();
}
